import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import {
  ApproveInfluencerPayload,
  InfluencerState,
  RejectInfluencerPayload,
  UpdateInfluencerContractPayload,
} from "./type";

export const getInfluencerList = createAsyncThunk(
  "web/influencer-list",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/influencers`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_INFLUENCERS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getInfluencerDetail = createAsyncThunk(
  "web/influencer-detail",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/influencers/${id}`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_INFLUENCER_DETAIL(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const approveInfluencer = createAsyncThunk(
  "web/approve-influencer",
  async (
    { id, payload }: { id: string; payload: ApproveInfluencerPayload },
    thunkAPI,
  ) => {
    try {
      const data = await axios.patch(
        `/admin/influencers/${id}/approve`,
        payload,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const rejectInfluencer = createAsyncThunk(
  "web/reject-influencer",
  async (
    { id, payload }: { id: string; payload: RejectInfluencerPayload },
    thunkAPI,
  ) => {
    try {
      const data = await axios.patch(
        `/admin/influencers/${id}/reject`,
        payload,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const updateInfluencerContract = createAsyncThunk(
  "web/update-influencer-contract",
  async (
    {
      id,
      payload,
    }: { id: string; payload: UpdateInfluencerContractPayload },
    thunkAPI,
  ) => {
    try {
      const data = await axios.put(
        `/admin/influencers/contracts/${id}`,
        payload,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const deleteInfluencerContract = createAsyncThunk(
  "web/delete-influencer-contract",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.delete(`/admin/influencers/contracts/${id}`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

const initialState: InfluencerState = {
  loading_influencers: false,
  influencers: undefined,
  loading_influencer_detail: false,
  influencer_detail: undefined,
  loading_influencer_approve: false,
  loading_influencer_reject: false,
  loading_influencer_contract_action: false,
};

export const influencerSlice = createSlice({
  name: "influencer",
  initialState,
  reducers: {
    SET_INFLUENCERS: (state, action) => {
      state.influencers = action.payload;
    },
    SET_INFLUENCER_DETAIL: (state, action) => {
      state.influencer_detail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInfluencerList.pending, (state) => {
        state.loading_influencers = true;
      })
      .addCase(getInfluencerList.fulfilled, (state) => {
        state.loading_influencers = false;
      })
      .addCase(getInfluencerList.rejected, (state) => {
        state.loading_influencers = false;
      })
      .addCase(getInfluencerDetail.pending, (state) => {
        state.loading_influencer_detail = true;
      })
      .addCase(getInfluencerDetail.fulfilled, (state) => {
        state.loading_influencer_detail = false;
      })
      .addCase(getInfluencerDetail.rejected, (state) => {
        state.loading_influencer_detail = false;
      })
      .addCase(approveInfluencer.pending, (state) => {
        state.loading_influencer_approve = true;
      })
      .addCase(approveInfluencer.fulfilled, (state) => {
        state.loading_influencer_approve = false;
      })
      .addCase(approveInfluencer.rejected, (state) => {
        state.loading_influencer_approve = false;
      })
      .addCase(rejectInfluencer.pending, (state) => {
        state.loading_influencer_reject = true;
      })
      .addCase(rejectInfluencer.fulfilled, (state) => {
        state.loading_influencer_reject = false;
      })
      .addCase(rejectInfluencer.rejected, (state) => {
        state.loading_influencer_reject = false;
      })
      .addCase(updateInfluencerContract.pending, (state) => {
        state.loading_influencer_contract_action = true;
      })
      .addCase(updateInfluencerContract.fulfilled, (state) => {
        state.loading_influencer_contract_action = false;
      })
      .addCase(updateInfluencerContract.rejected, (state) => {
        state.loading_influencer_contract_action = false;
      })
      .addCase(deleteInfluencerContract.pending, (state) => {
        state.loading_influencer_contract_action = true;
      })
      .addCase(deleteInfluencerContract.fulfilled, (state) => {
        state.loading_influencer_contract_action = false;
      })
      .addCase(deleteInfluencerContract.rejected, (state) => {
        state.loading_influencer_contract_action = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const { SET_INFLUENCERS, SET_INFLUENCER_DETAIL } =
  influencerSlice.actions;

export default influencerSlice.reducer;
